module.exports = __webpack_public_path__ + "img/IMG_4379.5aebb48c.jpg";